import "./scss/newsletter-moda-love.scss"

import { Form } from "../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../types/widget.props"

export function WidgetModaLove({ configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    return (
        <div className="news-moda-love news-footer">
            <div className="container flex center">
                <div className="news-title">
                    <h2>{textosPersonalizados.newsletterTitle}</h2>
                    <span>{textosPersonalizados.newsletterDescription}</span>
                </div>
                
                <Form
                    configuracaoSite={configuracaoSite}
                    textosPersonalizados={textosPersonalizados}
                    dinformname="newsletter-widget-moda-love"
                    hasFieldTelefone
                    className={{
                        form: "flex news-form",
                        nome: "nome",
                        email: "email",
                        telefone: "telefone",
                        button: "button"
                    }}
                />
            </div>
        </div>
    )
}

export default class WidgetModaLoveApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetModaLove {...props} />)
    }
}